import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { User } from '../../models/user.model';
import { ButtonComponent, InputComponent } from '../ui';

@Component({
  selector: 'app-users',
  imports: [CommonModule, FormsModule, ButtonComponent, InputComponent],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css'
})
export class UsersComponent {
  users = signal<User[]>([
    {
      id: '1',
      firstName: 'John',
      lastName: 'Doe',
      email: 'admin@healthcare.com',
      phone: '+1234567890',
      role: 'Admin',
      isActive: true,
      createdAt: new Date()
    },
    {
      id: '2',
      firstName: 'Sarah',
      lastName: 'Williams',
      email: 'sarah@healthcare.com',
      phone: '+1234567891',
      role: 'Doctor',
      specialization: 'Cardiology',
      department: 'Cardiology',
      licenseNumber: 'MD12345',
      isActive: true,
      createdAt: new Date()
    },
    {
      id: '3',
      firstName: 'Emily',
      lastName: 'Johnson',
      email: 'emily@healthcare.com',
      phone: '+1234567892',
      role: 'Nurse',
      department: 'Emergency',
      isActive: true,
      createdAt: new Date()
    }
  ]);

  showModal = signal(false);
  editingUser = signal<User | null>(null);
  userForm = signal<Partial<User>>({});

  openAddModal() {
    this.editingUser.set(null);
    this.userForm.set({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      role: 'Doctor',
      isActive: true
    });
    this.showModal.set(true);
  }

  openEditModal(user: User) {
    this.editingUser.set(user);
    this.userForm.set({ ...user });
    this.showModal.set(true);
  }

  closeModal() {
    this.showModal.set(false);
    this.editingUser.set(null);
  }

  saveUser() {
    const form = this.userForm();
    if (this.editingUser()) {
      this.users.update(users =>
        users.map(u => u.id === this.editingUser()!.id ? { ...u, ...form } : u)
      );
    } else {
      const newUser: User = {
        ...form,
        id: Date.now().toString(),
        createdAt: new Date()
      } as User;
      this.users.update(users => [...users, newUser]);
    }
    this.closeModal();
  }

  deleteUser(id: string) {
    if (confirm('Are you sure you want to delete this user?')) {
      this.users.update(users => users.filter(u => u.id !== id));
    }
  }
}

